/**
 * @typedef WorkflowNodeData
 * @type {{ label: string; [key: string]: any; }}
 */

/**
 * @typedef WorkflowNodeUI
 * @type {{ position: DiagramPosition; [key: string]: any }}
 */

/**
 * @typedef WorkflowNode
 * @type {{
 * node_uid: string;
 * type: NodeType | string;
 * data: WorkflowNodeData;
 * ui: WorkflowNodeUI;
 * dependencies?: string[];
 * }}
 */

/**
 * @typedef WorkflowEdge
 * @type {{
 * edge_uid: string;
 * source: string;
 * target: string;
 * label?: string;
 * }}
 */

/**
 * @typedef WorkflowDefinitionRaw
 * @type {{
 * nodes: WorkflowNode[];
 * edges: WorkflowEdge[];
 * }}
 */

/**
 * @typedef JourneyRawType
 * @type {{
 * journey: { name: string, description: string, status: string };
 * workflow: { name: string, type: string; definition: WorkflowDefinitionRaw };
 * }}
 */

/**
 * @typedef CanvasWorkflowNode
 * @type {{
 * id: string,
 * position: {x: number, y: number},
 * type: NodeType | string,
 * label: string,
 * icon: string,
 * hasInboundPort: boolean,
 * hasOutboundPort: boolean;
 * }}
 */

/** @typedef {'view' | 'edit'} WorkflowMode */

export const NodeType = {
  START: 'start',
  END: 'end',
  EMAIL: 'email',
  WHATSAPP: 'whatsapp',
  SMS: 'sms',
  RCS: 'rcs',
  UPDATE_ATTRIBUTE: 'update-attribute',
  TAG: 'tag',
  CASE: 'case',
  IF_ELSE: 'if-else',
  WAIT_UNTIL: 'wait_until',
  WAIT: 'wait',
  TEMPORARY: 'temporary',
  TIMER: 'timer',
  CONDITION: 'condition',
};
